"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  heightClass?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};

export default function VerticalImageGradiantNews({
  title = { hidden: false, value: "மதுரை மீனாட்சி சுந்தரேஸ்வரர் திருக்கல்யாண மகோற்சவம்", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  heightClass = "h-[500px]",
  priority = false,
  imageMetadata,
}: Props) {
  const titleValue = title?.value || "";
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <div className={`relative w-full ${heightClass} overflow-hidden`}>
      {/* Background Image */}
      {!imageSrc?.hidden && (
        <div className="absolute inset-0 w-full h-full">
          <Image
            src={imageSrcValue}
            alt={titleValue}
            fill
            priority={priority}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 500px"
            className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`}
            style={getFocusPointStyle(imageMetadata)}
            loading={priority ? "eager" : "lazy"}
            fetchPriority={priority ? "high" : "auto"}
            placeholder="blur"
            blurDataURL={BLUR_PLACEHOLDER}
          />
        </div>
      )}

      {/* Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-blue-900 to-transparent">
        {/* Title */}
        {!title?.hidden && (
          <h3 className={`absolute bottom-4 left-4 right-4 text-FFFFFF text-xl font-bold ${title?.customClass || ""}`}>
            {titleValue}
          </h3>
        )}
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:opacity-90 transition-opacity cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
}